import { useEffect, useState } from "react";
import dynamic                 from "next/dynamic";
import remoteConfigInstance    from "_services/firebase/fetchRemoteConfig";
import { useDisclosure }       from "@mantine/hooks";

const Presentation = dynamic ( () => import ( "./presentation" ) );

const TournamentBanner = () => {
	const [ bannerInfo, setBannerInfo ] = useState ( null );
	const [ opened, { toggle } ]        = useDisclosure ( true );

	useEffect ( () => {
		fetchBanner ();
	}, [] );

	const fetchBanner = async () => {
		const remoteConfig = await remoteConfigInstance.getData ( "sportx", "tournament_banner" );

		if ( !remoteConfig )
			return;

		setBannerInfo ( remoteConfig );

	};

	const handleRedirectClick = () => {
		window.open ( bannerInfo?.redirectTo, "_blank" );
	};

	if ( !bannerInfo || !bannerInfo?.enabled )
		return null;

	return (
		<Presentation
			bannerInfo          = { bannerInfo }
			handleRedirectClick = { handleRedirectClick }
			opened              = { opened }
			toggle              = { toggle }
		/>
	);
};

export default TournamentBanner;
